import request from 'superagent';
import postal from 'postal';
import moment from 'moment';
import auth0 from './auth0';
import appConfig from '../config/appConfig';

const channel = postal.channel('ajax');

const handleError = err => {
  console.error('Error while communicating with server', err.message, err.stack);

  if (err.statusCode === 400) {
    const title = 'Validierungsfehler';
    const message = err.rawResponse || '...die übermittelten Daten sind nicht korrekt.';

    channel.publish('ajaxerror.add', {
      title,
      message
    });
  } else {
    const message = '...bei der Kommunikation mit Server';

    channel.publish('ajaxerror.add', {
      message: message
    });
  }
};

function performRequestWithToken(req, successCallback, errorCallback, accessToken) {
  channel.publish('ajax.begin', {});

  req = req.set('Authorization', 'Bearer ' + accessToken);

  // Admins can specify which role they want to use for testing purposes
  const overrideRoleName = auth0.getOverrideRoleName();
  if(overrideRoleName) {
    req = req.set('X-OverrideRole', overrideRoleName);
  }

  req.end((error, res) => {
    channel.publish('ajax.end', {});

    if(error) {
      if(errorCallback) {
        if(error.response) {
          errorCallback(error.response.body);
        } else {
          errorCallback(error.rawResponse);
        }
      } else {
        handleError(error);
      }

      return;
    }

    successCallback(res.body);
  });
}

function performRequest(params) {
  let {
    url,
    data,
    method = 'get',
    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    success,
    error,
    responseType,
  } = params;

  let req = request[method](url)
    .set(headers);

  if(data) {
    if (['get', 'del'].indexOf(method) > -1) {
      req = req.query(data);
    } else { // POST or PUT
      req = req.send(data);
    }
  }
  if(responseType) {
    req.responseType(responseType);
  }

  const isAuthenticated = auth0.isAuthenticated()

  if(isAuthenticated) {
    const expirationDate = auth0.getTokenExpirationDate();
    const currentDate = moment();
    const tokenExpiresInHours = moment.duration(expirationDate.diff(currentDate)).asHours();

    if (tokenExpiresInHours <= 4) {
      const tokenRefreshRequest = request['post'](appConfig.serverUrl + 'auth/refresh');

      performRequestWithToken(tokenRefreshRequest,
        res => {
          auth0.setTokenData(res.token);
        },
        err => {
          console.error("Refreshing token failed", err);
          auth0.logout();
          window.location.reload();
        },
        auth0.getAccessToken());
    }

    performRequestWithToken(req, success, error, auth0.getAccessToken());
  } else {
    // TODO: Schöner machen
    window.location.reload();
  }
}

export default {
  get: params => performRequest(Object.assign({ method: 'get' }, params)),
  post: params => performRequest(Object.assign({ method: 'post' }, params)),
  put: params => performRequest(Object.assign({ method: 'put' }, params)),
  del: params => performRequest(Object.assign({ method: 'del' }, params)),
};



// WEBPACK FOOTER //
// ./src/helpers/request.js